import { apiPost } from '../../../core/utils/api/generic'

export const apiCreateIntake = async (form_uuid: string): Promise<any> => apiPost(`/forms/${form_uuid}/create-intake`)
export default apiCreateIntake
